<template>
  <div class="tags-container">
    <div class="others">
      <div class="container_media">
        <div class="tag-row">
          <div class="title">分类：</div>
          <div class="tags-wrap">
            <span :class="{ active_label: firstActiveKey == -1 }" @click="chooseFirstTag({ label_id: -1 })">全部</span>
            <span
              v-for="tag in tagList"
              :key="tag.label_id"
              :class="{ active_label: firstActiveKey == tag.label_id }"
              @click="chooseFirstTag(tag)"
            >{{ tag.label_name }}</span>
          </div>
        </div>
        <div class="tag-row" v-if="firstActiveKey != -1">
          <div class="title">场景：</div>
          <div class="tags-wrap">
            <span
              v-for="sonTag in firstActiveTag.son"
              :key="sonTag.label_id"
              :class="{ active_label: chooseTagList.includes(sonTag) || secondActiveKey.label_id == sonTag.label_id }"
              @click="chooseSecondTag(sonTag)"
            >{{ sonTag.name || sonTag.label_name }}</span>
          </div>
        </div>
        <div class="third-label" v-if="thirdTagsList.length">
          <div class="tags-wrap">
            <span
              v-for="tTag in thirdTagsList"
              :key="`tTag${tTag.label_id}`"
              :class="{ t_active_label: chooseTagList.includes(tTag) }"
              @click="chooseThirdTag(tTag)"
            >{{ tTag.label_name }}</span>
          </div>
        </div>
        <div class="tag-sort-box">
          <div class="tag_sort">
            <div class="tag_sort_title">排序：</div>
            <div class="tag_sort_content">
              <span
                v-for="(item, index) in orderList"
                :key="index"
                :class="{ active_label: item.value == orderNo }"
                @click="setOrder(item)"
              >{{ item.label }}</span>
            </div>
          </div>
          <div class="tag-pagina">
            <i class="pagina_l el-icon-arrow-left" :class="{ active: lpage }" @click="prevPage"></i>
            <span class="pager">
              <i class="page">{{ pager.page }}</i>
              <i class="pagesize">/{{ pages || '...' }}</i>
            </span>
            <i class="pagina_r el-icon-arrow-right" :class="{ active: rpage }" @click="nextPage"></i>
          </div>
        </div>
      </div>
    </div>
    <div v-if="chooseTagList.length" class="selected-tag-box container_media">
      <span class="title"><i>搜索结果</i><em>|</em> 已选标签：</span>
      <el-tag
        v-for="item in chooseTagList"
        :key="`check_${item.label_id}`"
        size="small"
        closable
        @close="handleCloseTag(item)"
      >{{ item.label_name }}</el-tag>
      <span class="clean" @click="cleanTagSearch">全部清除</span>
    </div>
  </div>
</template>

<script>
import { fetchVideoTags } from '@/api/video'
import { orderList } from '@/config'

export default {
  name: 'SearchVideoTagsFilter',
  props: {
    pager: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tagList: [],
      firstActiveTag: {},
      firstActiveKey: -1,
      secondActiveKey: {},
      chooseTagList: [],
      thirdTagsList: [],
      orderList,
      orderNo: '',
      lpage: false,
      rpage: false
    }
  },
  computed: {
    pages() {
      if (!this.pager.limit) return 0
      return Math.ceil(this.pager.total / this.pager.limit)
    }
  },
  created() {
    this.getTags()
  },
  methods: {
    async getTags() {
      try {
        const { data } = await fetchVideoTags()
        this.tagList = data?.length ? data : []
      } catch (e) {
        console.error(e)
      }
    },
    emitChange() {
      this.$emit('change', {
        label_id: this.chooseTagList.map((i) => i.label_id).join(','),
        order: this.orderNo
      })
    },
    chooseFirstTag(tag) {
      if (this.firstActiveTag == tag && tag.label_id == -1) return
      if (this.firstActiveTag == tag) {
        this.firstActiveTag = { label_id: -1 }
        this.firstActiveKey = -1
      } else {
        this.firstActiveTag = tag
        this.firstActiveKey = tag.label_id
      }
      if (tag.label_id == -1) {
        this.chooseTagList = []
        this.emitChange()
      }
      this.thirdTagsList = []
      this.secondActiveKey = {}
    },
    chooseSecondTag(tag) {
      if (tag.son) {
        if (tag == this.secondActiveKey) {
          this.thirdTagsList = []
          this.secondActiveKey = {}
        } else {
          this.thirdTagsList = tag.son
          this.secondActiveKey = tag
        }
      } else {
        const index = this.chooseTagList.findIndex((i) => i.label_id === tag.label_id)
        if (index > -1) {
          this.chooseTagList.splice(index, 1)
        } else {
          this.chooseTagList.push(tag)
        }
        this.thirdTagsList = []
        this.secondActiveKey = {}
        this.emitChange()
      }
    },
    chooseThirdTag(tag) {
      const index = this.chooseTagList.findIndex((i) => i.label_id === tag.label_id)
      if (index > -1) {
        this.chooseTagList.splice(index, 1)
      } else {
        this.chooseTagList.push(tag)
      }
      this.emitChange()
    },
    setOrder(item) {
      this.orderNo = item.value
      this.emitChange()
    },
    handleCloseTag(item) {
      const index = this.chooseTagList.findIndex((i) => i.label_id === item.label_id)
      this.chooseTagList.splice(index, 1)
      this.emitChange()
    },
    cleanTagSearch() {
      this.chooseTagList = []
      this.thirdTagsList = []
      this.secondActiveKey = {}
      this.firstActiveKey = -1
      this.firstActiveTag = { label_id: -1 }
      this.orderNo = ''
      this.emitChange()
    },
    prevPage() {
      if (this.pager.page < 2) return
      this.$emit('pageChange', { page: this.pager.page - 1 })
      this.lpage = true
      this.rpage = false
    },
    nextPage() {
      if (this.pager.page < this.pages) {
        this.$emit('pageChange', { page: this.pager.page + 1 })
        this.lpage = false
        this.rpage = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './tags-filter-shell.scss';
</style>
